import { useVersion } from "./api";

export function VersionBadge() {
  const q = useVersion();
  if (!q.data) return null;
  const d = q.data;
  const built = d.built_at.length >= 10 ? d.built_at.slice(0, 10) : d.built_at;
  const tooltip = [
    `Go ${d.go_version}`,
    d.saas_common_version ? `saas-common ${d.saas_common_version}` : "",
    d.admin_design_version ? `admin-design ${d.admin_design_version}` : "",
  ]
    .filter(Boolean)
    .join(" · ");
  return (
    <span
      className="font-mono text-xs text-muted-foreground whitespace-nowrap"
      title={tooltip}
    >
      v{d.version} · {d.commit_short} · {built}
    </span>
  );
}
